var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-tabs",
        {
          scopedSlots: _vm._u([
            {
              key: "tabBarExtraContent",
              fn: function() {
                return [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.EditActivity()
                        }
                      }
                    },
                    [_vm._v("活動編輯")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.activeKey,
            callback: function($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey"
          }
        },
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: "1.場館設定" } },
            [_c("venue-edit-form")],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: "2.座位分組" } },
            [_c("set-group-seat-form")],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "3", attrs: { tab: "3.人員信息" } },
            [_c("person-list")],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "4", attrs: { tab: "4.分配座位" } },
            [_c("seat-assign-form")],
            1
          )
        ],
        1
      ),
      _c("activity-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }